import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import DataTable from "react-data-table-component";
import { downloadFile } from "services/ConfigServices";
import { energyData } from "variables/lists/bills";
import { dico } from "variables/lists/dico";

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataMargin = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function ViewSubBillDialog(props) {
  const { closeModal, subbill } = props;

  const [valueChoiceData, setValueChoiceData] = useState([]);
  const [valueChoice, setValueChoice] = useState("raw");
  const [data, setData] = useState([]);
  const classes = useStyles();

  const handleValueChoiceChange = (event) => { setValueChoice(event.target.value); };
  console.log(subbill);

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.key,
      sortable: true,
      cell: (row) => row.key ?
        <div>
          {dico.find((x) => x.id == row.key).name}
        </div> : <></>
    },
    {
      name: "Date de début",
      selector: (row) => row.begin,
      sortable: true,
      maxWidth: "9rem",
      cell: (row) =>
        row.begindate && moment(row.begindate).isValid()
          ? moment(row.begindate).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Date de fin",
      selector: (row) => row.end,
      sortable: true,
      maxWidth: "9rem",
      cell: (row) =>
        row.enddate && moment(row.enddate).isValid()
          ? moment(row.enddate).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Valeur",
      selector: (row) => row.value,
      sortable: true,
      maxWidth: "9rem",
      cell: (row) => new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 5 }).format(row.value)
    },
    {
      name: "Unité",
      selector: (row) => row.unit,
      sortable: true,
      maxWidth: "4rem",
      cell: (row) => row.key ?
        <div>
          {dico.find((x) => x.id == row.key).unit}
        </div> : <></>
    },
    {
      name: "% appliqué",
      selector: (row) => row.divisionvalused,
      sortable: true,
      omit: valueChoice === 'raw',
      maxWidth: "7rem",
      cell: (row) =>
        <div>{row.divisionvalused ? (100 * row.divisionvalused).toString() + '%' : '100%'}</div>,
    },
  ];

  const downloadGED = (fileId, fileName) => async () => {
    axios
      .get(
        downloadFile(fileId, 'import'),
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((response) => {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  useEffect(() => {
    const choiceData = [];
    console.log(subbill);
    choiceData.push({ name: 'Données brutes de la facture', id: 'raw' });
    if (subbill?.sitesdata) {
      Object.keys(subbill.sitesdata).forEach(function (key) {
        if (subbill.sitesdata[key].divisionunit && subbill.sitesdata[key].divisionvalue) {
          if (subbill.sitesdata[key].divisionunit === "percent")
            choiceData.push({ name: "Données réparties sur '" + subbill.sitesdata[key].name + "' (" + (subbill.sitesdata[key].divisionvalue).toString() + "%)", id: key });
          else
            choiceData.push({ name: "Données réparties sur '" + subbill.sitesdata[key].name + "' (" + (subbill.sitesdata[key].divisionvalue).toString() + "m²)", id: key });
        }
        else
          choiceData.push({ name: "Données réparties sur '" + subbill.sitesdata[key].name + "'", id: key });
      });
    }
    setValueChoiceData(choiceData);
  }, [subbill]);

  useEffect(() => {
    if (subbill) {
      if (valueChoice === 'raw') {
        setData(subbill.rawdata);
      }
      else {
        setData(subbill.sitesdata[valueChoice].data);
      }
    }

  }, [valueChoice, subbill]);


  return (
    <>
      <form className={classes.root}>
        {subbill &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <DataList>
                {(subbill.billcanceled && subbill.billcanceled == 1) ?
                  <DataContainer>
                    <Data>{"FACTURE ANNULEE"}</Data>
                    { (subbill.cancellationbill  && subbill.cancellationbill.file) ?
                      <DataResultLink onClick={downloadGED(subbill.cancellationbill.file.fileid, subbill.cancellationbill.file.filename)}>
                        {subbill.cancellationbill.file.filename}
                      </DataResultLink> : <></>
                    }

                  </DataContainer> : <></>
                }
                <DataContainer>
                  <Data>{"Facture n°"}</Data>
                  <DataResult>{subbill.docreference}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Fluide"}</Data>
                  <DataResult>{energyData.find((x) => x.id == subbill.energy)?.name}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Fournisseur"}</Data>
                  <DataResult>{subbill.sender}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"PDL"}</Data>
                  <DataResult>{subbill.pdl}</DataResult>
                </DataContainer>
                {subbill.file && <DataContainer>
                  <Data>{"Fichier source"}</Data>
                  <DataResultLink onClick={downloadGED(subbill.file.fileid, subbill.file.filename)}>
                    {subbill.file.filename}
                  </DataResultLink>
                </DataContainer>}
                <DataContainer>
                  <Data>{"Date de facture"}</Data>
                  <DataResult>{subbill.billdate && moment(subbill.billdate).isValid()
                    ? moment(subbill.billdate).format("DD/MM/YYYY")
                    : ""}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Date de début"}</Data>
                  <DataResult>{subbill.begin && moment(subbill.begin).isValid()
                    ? moment(subbill.begin).format("DD/MM/YYYY")
                    : ""}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Date de fin"}</Data>
                  <DataResult>{subbill.end && moment(subbill.end).isValid()
                    ? moment(subbill.end).format("DD/MM/YYYY")
                    : ""}</DataResult>
                </DataContainer>
              </DataList>
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div>
                <CustomSelect
                  inputTitle={"Valeurs"}
                  selectValue={valueChoice}
                  handleSelectValueChange={handleValueChoiceChange}
                  data={valueChoiceData}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <Container>
                <DataTable
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                  dense
                  noDataComponent={<NoData>Aucun PDL à afficher</NoData>}
                  noHeader={true}
                  columns={columns}
                  persistTableHead
                  data={data}
                />
              </Container>
            </GridItem>
          </GridContainer>}
      </form>
    </>
  );
}

export default ViewSubBillDialog;
